/* HIKMATI a11y enhancements (keine Designänderung).
   1) featured-tabs: vollständiges Tab-Muster (tablist, aria-selected, roving tabindex,
      Pfeiltasten/Home/End/Space/Enter, Panel-Zuordnung).
   2) Überschriftenhierarchie per aria-level (Tag und Optik bleiben unverändert).
   3) Warenkorb ohne Artikel: sichtbarer Titel erhält role=heading aria-level=1. */
(function () {
  'use strict';
  var uid = 0;

  function enhanceTabs(host) {
    if (host.__hkTabs) return;
    var firstTab = host.querySelector('.featured-tabs__item');
    if (!firstTab) return;
    host.__hkTabs = true;
    var list = firstTab.parentElement;
    list.setAttribute('role', 'tablist');
    var label = host.querySelector('h2, h3') || host.closest('section, .shopify-section');
    var heading = label && label.querySelector ? (label.matches('h2,h3') ? label : label.querySelector('h2, h3')) : null;
    if (heading && heading.textContent.trim()) list.setAttribute('aria-label', heading.textContent.trim());
    else list.setAttribute('aria-label', 'Produktkategorien');
    var base = 'hk-tabs-' + (++uid);

    function tabs() { return Array.prototype.slice.call(host.querySelectorAll('.featured-tabs__item')); }
    function panels() {
      var scope = host.closest('.shopify-section') || host.parentElement || document;
      var c = scope.querySelector('featured-tabs-content');
      return c ? Array.prototype.slice.call(c.children) : [];
    }
    function sync() {
      var ts = tabs(), ps = panels();
      var active = ts.filter(function (t) { return t.classList.contains('active'); })[0] || ts[0];
      ts.forEach(function (t, i) {
        var isA = t === active;
        if (!t.id) t.id = base + '-tab-' + i;
        t.setAttribute('role', 'tab');
        t.setAttribute('aria-selected', isA ? 'true' : 'false');
        t.setAttribute('tabindex', isA ? '0' : '-1');
        var p = ps.filter(function (x) { return x.getAttribute('data-index') === t.getAttribute('data-index'); })[0];
        if (p) {
          if (!p.id) p.id = base + '-panel-' + i;
          t.setAttribute('aria-controls', p.id);
          p.setAttribute('role', 'tabpanel');
          p.setAttribute('aria-labelledby', t.id);
        }
      });
      ps.forEach(function (p) {
        if (!p.getAttribute('role')) p.setAttribute('role', 'tabpanel');
      });
    }
    sync();
    new MutationObserver(sync).observe(host.closest('.shopify-section') || host, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });

    list.addEventListener('keydown', function (e) {
      var t = e.target.closest ? e.target.closest('.featured-tabs__item') : null;
      if (!t) return;
      var ts = tabs(), i = ts.indexOf(t), n = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % ts.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + ts.length) % ts.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = ts.length - 1;
      else if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); t.click(); return; }
      else return;
      e.preventDefault();
      ts[n].click();
      ts[n].focus();
    });
  }

  function headings() {
    var canon = document.querySelector('link[rel="canonical"]');
    var isProduct = !!(canon && /\/products\//.test(canon.href));
    var isCollection = !!document.querySelector('main [id*="product-grid"], main .collection');
    document.querySelectorAll('h3, h4, h5, h6').forEach(function (h) {
      if (h.hasAttribute('aria-level')) return;
      if (h.closest('.product-card__heading') && isCollection) { h.setAttribute('aria-level', '2'); return; }
      if (isProduct && h.matches('h6.mt0, h5.mt0, h4.mt0') && (h.closest('[class*="section-text-with-icons"]') ||
          h.classList.contains('heading-color-block-main'))) {
        h.setAttribute('aria-level', '2');
      }
    });
    var cartTitle = document.querySelector('.cart__warnings__heading');
    if (!cartTitle || cartTitle.getAttribute('role') === 'heading') return;   // Layout nur lesen, wenn der Warenkorb-Titel existiert
    var visibleH1 = Array.prototype.some.call(document.querySelectorAll('main h1, [role="heading"][aria-level="1"]'), function (x) {
      return x.getClientRects().length > 0 && getComputedStyle(x).visibility !== 'hidden';
    });
    if (cartTitle.getClientRects().length > 0 && !visibleH1) {
      cartTitle.setAttribute('role', 'heading');
      cartTitle.setAttribute('aria-level', '1');
    }
  }

  function landmarks() {
    var fc = document.querySelector('.footer__content');
    if (!fc) return;
    Array.prototype.forEach.call(fc.children, function (s) {
      if (s.getAttribute('role') || s.querySelector('footer')) return;
      var nav = s.querySelector('footersticky-nav');
      if (nav) { nav.setAttribute('role', 'navigation'); nav.setAttribute('aria-label', 'Schnellnavigation'); return; }
      var h = s.querySelector('h1, h2, h3');
      s.setAttribute('role', 'region');
      s.setAttribute('aria-label', (h && h.textContent.trim()) || 'Weitere Informationen');
    });
  }

  function decorativeButtonText() {
    document.querySelectorAll('.btn__bottom-text:not([aria-hidden="true"])').forEach(function (copy) {
      copy.setAttribute('aria-hidden', 'true');
    });
  }

  function run() {
    decorativeButtonText();
    document.querySelectorAll('featured-tabs').forEach(enhanceTabs);
    headings();
    landmarks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  // Gebuendelt und verzoegert, damit viele DOM-Aenderungen (Tabs, Bilder, Apps) keine wiederholten Layout-Berechnungen ausloesen.
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      run();
    }, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
